/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BannerAnnouncement } from '../../models/banner-announcement';
import { FeatureAnnouncement } from '../../models/feature-announcement';
import { HeadlineAnnouncement } from '../../models/headline-announcement';
import { ImportantDatesAnnouncement } from '../../models/important-dates-announcement';

export interface UpdateAnnouncement$Params {
  id: number;
      body: (BannerAnnouncement | FeatureAnnouncement | HeadlineAnnouncement | ImportantDatesAnnouncement)
}

export function updateAnnouncement(http: HttpClient, rootUrl: string, params: UpdateAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateAnnouncement.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateAnnouncement.PATH = '/announcements/{id}';
